import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Select,
  Spinner,
  ButtonGroup,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate, useParams } from "react-router-dom";
import { usavigate } from "react-router-dom";
import {
  ExportIcon,
  ImportIcon,
  NoteIcon,
  OutgoingIcon,
  PlusIcon,
} from "@shopify/polaris-icons";
import Select2 from "react-select";
import axios2 from "axios";
import LoadingScreen from "../../Components/LoadingScreen";
import { TimePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
const BulkSessions = () => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [sessions, setSessions] = useState([
    // {
    //   class: "",
    //   instructor: "",
    //   date: "",
    //   start_time: "",
    //   end_time: "",
    //   gender_type: "",
    //   capacity_male: "",
    //   capacity_female: "",
    //   capacity_total: "",
    //   location: "default",
    //   location_other: "",
    //   // id: "",
    // },
  ]);
  const handleAddSession = () => {
    setSessions((prevItems) => [
      ...prevItems,
      {
        class: "",
        instructor: "",
        date: "",
        start_time: "",
        end_time: "",
        // start_time: new Date(""),
        // end_time: new Date(""),
        gender_type: "",
        capacity_male: "",
        capacity_female: "",
        capacity_total: "",
        location: "default",
        location_other: "",
        external_capacity: "",
        // id: "",
      },
    ]);
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const handleRemoveSession = (index) => {
    const updatedSessions = [...sessions];
    updatedSessions.splice(index, 1);
    setSessions(updatedSessions);
  };
  const handleChangeSession = (index, field, value) => {
    console.log(value);
    const updatedSessions = [...sessions];
    updatedSessions[index][field] = value;
    setSessions(updatedSessions);
  };
  const [optionsClasses, setOptionsClasses] = useState([]);
  const [optionsInstructors, setOptionsInstructors] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [ts, setTs] = useState("");
  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseClasses = "";
    let responseInstructors = "";
    let responseSessions = [];
    try {
      responseClasses = await axios.get(`/classes?per_page=1000`);
      setOptionsClasses(
        responseClasses.data.data.data.map((item, index) => {
          return {
            label: item.name + ` (ID: ${item.id})`,
            value: String(item.id),
          };
        }),
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseInstructors = await axios.get(`/instructors?per_page=1000`);
      setOptionsInstructors(
        responseInstructors.data.data.data.map((item, index) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        }),
      );
    } catch (error) {
      console.log(error);
    }
    try {
      console.log("testtt=", convertToFullDate("07:05:00"));
      responseSessions = await axios.get(`/bulk-sessions`);
      console.log(responseSessions.data.data);
      responseSessions.data.data && responseSessions.data.data.length
        ? setSessions(
            responseSessions.data.data.map((item) => ({
              start_time: item.launch_time,
              end_time: item.finish_time,
              // start_time: new Date(convertToFullDate(item.launch_time)),
              // end_time: new Date(convertToFullDate(item.finish_time)),
              gender_type: item.gender,
              instructor: {
                label: item?.instructor?.name,
                value: String(item.instructor?.id),
              },
              class: {
                label: item?.related_class?.name,
                value: String(item.related_class?.id),
              },
              date: item.date,
              capacity_female: item.capacity_female,
              capacity_male: item.capacity_male,
              capacity_total: item.capacity,
              id: item.id,
              location: item.location,
              location_other: item.other_location,
              external_capacity: item.external_capacity || "",
            })),
          )
        : setSessions([]);
    } catch (error) {
      console.log(error);
    }
    setIsSaving(false);
    setDataFetched(true);
  }
  const [activeImport, setActiveImport] = useState(false);

  const handleChangeModalImport = useCallback((activeImport) => {
    setActiveImport(!activeImport);
    setIsSaving(false);
  }, []);

  const handlePublish = () => {
    setIsSaving(true);
    axios
      .post(`/publish/bulk-sessions`)
      .then((result) => {
        setIsSaving(false);
        setToastContent("Sessions have been published successfully");
        toggleActive();
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };

  const handleImport = () => {
    const form_data = new FormData();
    form_data.append("csv_file", files[files.length - 1]);
    setIsSaving(true);
    axios
      .post(`/import/bulk-sessions`, form_data)
      .then((result) => {
        setIsSaving(false);
        setToastContent("Sessions have been imported successfully");
        toggleActive();
        setActiveImport(false);
        setTs(+new Date());
      })
      .catch((error) => {
        console.log("error=", error.response.data.errors[0]);
        setIsSaving(false);
        setImportError(error.response.data.errors[0]);
        console.log(error.config);
      });
  };
  const handleExport = () => {
    setIsSaving(true);
    const headers = { Authorization: "Bearer h_YGrV*wAO/EBL1uCh'z!i" };
    axios2
      .get(`${process.env.REACT_APP_BASE_URL}/export/bulk-sessions`, {
        headers,
      })
      .then((result) => {
        setIsSaving(false);
        window.open(result.data.data, "_blank");
      })
      .catch((err) => console.log(err));
  };
  const [error, setError] = useState("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const imageKey = useRef("");
  const [files, setFiles] = useState([]);
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    [],
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload actionHint={"Accepts csv"} />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImage = (files) => {
    // setIsImageUploading(true);
    //const form_data = new FormData();
    // form_data.append("entity", "instructor");
    // form_data.append("image", files[files.length - 1]);
    // axios
    //   .post(`/s3/save-file`, form_data)
    //   .then((result) => {
    //     imageKey.current = result.data.data;
    //     setIsImageUploading(false);
    //     setImageError("");
    //     // setItem({
    //     //   ...item,
    //     //   image:
    //     //     validImageTypes.indexOf(files[files.length - 1].type) > 0
    //     //       ? window.URL.createObjectURL(files[files.length - 1])
    //     //       : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    //     // });
    //   })
    //   .catch(function (error) {});
  };

  const [importError, setImportError] = useState("");
  const [imageError, setImageError] = useState("");
  const formatTime = (date) => {
    if (!date) return "";
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };
  const convertToFullDate = (time) => {
    // Get the current date
    const currentDate = new Date();

    // Split the time into hours, minutes, and seconds
    const [hours, minutes, seconds] = time.split(":").map(Number);

    // Set the time to the current date
    currentDate.setHours(hours);
    currentDate.setMinutes(minutes);
    currentDate.setSeconds(seconds);
    currentDate.setMilliseconds(0); // Set milliseconds to 0

    // Convert the date to a string with full date format
    return currentDate.toString();
  };
  return (
    <Page
      title="Bulk Add Sessions"
      backAction={{
        onAction: () => navigate(`/admin/classes`),
      }}
      fullWidth
      primaryAction={
        <ButtonGroup>
          <Button
            variant="primary"
            onClick={() => setActiveImport(true)}
            loading={isSaving}
            icon={ImportIcon}
          >
            Import
          </Button>
          <Button
            variant="primary"
            onClick={handleExport}
            loading={isSaving}
            icon={ExportIcon}
          >
            Export
          </Button>
          <Button
            variant="primary"
            onClick={handlePublish}
            loading={isSaving}
            icon={OutgoingIcon}
          >
            Publish
          </Button>
        </ButtonGroup>
      }
    >
      {isSaving ? <Loading /> : null}
      <Card>
        {dataFetched ? (
          <div
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              border: "1px solid #ddd",
            }}
          >
            <FormLayout>
              <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left", padding: "8px" }}>Class</th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Instructor
                    </th>
                    <th style={{ textAlign: "left", padding: "8px" }}>Date</th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Start Time
                    </th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      End Time
                    </th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Gender
                    </th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Capacity
                    </th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Location
                    </th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      Other Location
                    </th>
                    <th style={{ textAlign: "left", padding: "8px" }}>
                      External Capacity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sessions?.map((session, index) => (
                    <tr key={index}>
                      <td style={{ padding: "8px", width: "100px" }}>
                        <Select2
                          options={optionsClasses}
                          onChange={(value) =>
                            handleChangeSession(index, "class", value)
                          }
                          value={session.class}
                          placeholder="Please select"
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "300px",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "150px",
                              overflowY: "auto",
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "150px",
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          menuPosition="absolute"
                        />
                        {/* <Select
                          options={optionsClasses}
                          onChange={(value) =>
                            handleChangeSession(index, "class", value)
                          }
                          value={session.class}
                          placeholder="Please select"
                        /> */}
                      </td>
                      <td style={{ padding: "8px" }}>
                        <Select2
                          options={optionsInstructors}
                          onChange={(value) =>
                            handleChangeSession(index, "instructor", value)
                          }
                          value={session.instructor}
                          placeholder="Please select"
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "300px",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "150px",
                              overflowY: "auto",
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "150px",
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          menuPosition="absolute"
                        />
                      </td>
                      <td style={{ padding: "8px" }}>
                        <TextField
                          type="date"
                          value={session.date}
                          onChange={(value) =>
                            handleChangeSession(index, "date", value)
                          }
                        />
                      </td>
                      <td style={{ padding: "8px" }}>
                        <TextField
                          type="time"
                          value={session.start_time}
                          onChange={(value) =>
                            handleChangeSession(index, "start_time", value)
                          }
                          step="60"
                        />
                        {/* <TimePicker
                          format="hh:mm aa"
                          value={session.start_time}
                          onChange={(value) =>
                            handleChangeSession(index, "start_time", value)
                          }
                          placeholder="Select time"
                          style={{ width: "150px" }}
                          showMeridiem
                        /> */}
                      </td>
                      <td style={{ padding: "8px" }}>
                        {/* <TimePicker
                          format="hh:mm aa"
                          value={session.end_time}
                          onChange={(value) =>
                            handleChangeSession(index, "end_time", value)
                          }
                          placeholder="Select time"
                          style={{ width: "150px" }}
                          showMeridiem
                        /> */}
                        <TextField
                          type="time"
                          value={session.end_time}
                          onChange={(value) =>
                            handleChangeSession(index, "end_time", value)
                          }
                        />
                      </td>
                      <td style={{ padding: "8px" }}>
                        <Select
                          options={[
                            { label: "Male", value: "male" },
                            { label: "Female", value: "female" },
                            {
                              label: "Mixed (With male,female capacities)",
                              value: "mixed",
                            },
                            {
                              label: "Mixed (With total capacity)",
                              value: "mixed_total",
                            },
                          ]}
                          onChange={(value) =>
                            handleChangeSession(index, "gender_type", value)
                          }
                          value={session.gender_type}
                          placeholder="Please select"
                        />
                      </td>
                      <td style={{ padding: "8px" }}>
                        {session?.gender_type === "female" ? (
                          <TextField
                            value={session.capacity_female}
                            onChange={(value) =>
                              handleChangeSession(
                                index,
                                "capacity_female",
                                value,
                              )
                            }
                          />
                        ) : session?.gender_type === "male" ? (
                          <TextField
                            value={session.capacity_male}
                            onChange={(value) =>
                              handleChangeSession(index, "capacity_male", value)
                            }
                          />
                        ) : session.gender_type === "mixed_total" ? (
                          <TextField
                            value={session.capacity_total}
                            onChange={(value) =>
                              handleChangeSession(
                                index,
                                "capacity_total",
                                value,
                              )
                            }
                          />
                        ) : (
                          <div className="rowDiv" style={{ minWidth: "150px" }}>
                            <TextField
                              value={session.capacity_female}
                              onChange={(value) =>
                                handleChangeSession(
                                  index,
                                  "capacity_female",
                                  value,
                                )
                              }
                            />
                            <div style={{ marginLeft: "0.6rem" }}>
                              <TextField
                                value={session.capacity_male}
                                onChange={(value) =>
                                  handleChangeSession(
                                    index,
                                    "capacity_male",
                                    value,
                                  )
                                }
                              />
                            </div>
                          </div>
                        )}
                      </td>
                      <td style={{ padding: "8px" }}>
                        <Select
                          options={[
                            { label: "Default Location", value: "default" },
                            { label: "Other", value: "other" },
                          ]}
                          onChange={(value) =>
                            handleChangeSession(index, "location", value)
                          }
                          value={session.location}
                          placeholder="Please select"
                        />
                      </td>
                      <td>
                        {session.location === "other" ? (
                          <TextField
                            value={session.location_other}
                            onChange={(value) =>
                              handleChangeSession(
                                index,
                                "location_other",
                                value,
                              )
                            }
                          />
                        ) : null}
                      </td>
                      <td style={{ padding: "8px" }}>
                        <TextField
                          type="number"
                          value={session.external_capacity}
                          onChange={(value) =>
                            handleChangeSession(
                              index,
                              "external_capacity",
                              value,
                            )
                          }
                        />
                      </td>
                      <td>
                        <div style={{ marginLeft: "1rem" }}>
                          <Button
                            onClick={() => handleRemoveSession(index)}
                            variant="primary"
                            tone="critical"
                          >
                            Remove
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* {sessions?.map((session, index) => (
            <div key={index}>
              <FormLayout>
                <FormLayout.Group condensed>
                  <Select
                    label={index === 0 ? "Class" : ""}
                    options={optionsClasses}
                    onChange={(value) =>
                      handleChangeSession(index, "class", value)
                    }
                    value={session.class}
                    placeholder="Please select"
                  />
                  <Select
                    label={index === 0 ? "Instructor" : ""}
                    options={optionsInstructors}
                    onChange={(value) =>
                      handleChangeSession(index, "instructor", value)
                    }
                    value={session.instructor}
                    placeholder="Please select"
                  />
                  <TextField
                    type="date"
                    label={index === 0 ? "Date" : ""}
                    value={session.date}
                    onChange={(value) =>
                      handleChangeSession(index, "date", value)
                    }
                  />
                  <TextField
                    type="time"
                    label={index === 0 ? "Start Time" : ""}
                    value={session.start_time}
                    onChange={(value) =>
                      handleChangeSession(index, "start_time", value)
                    }
                  />
                  <TextField
                    type="time"
                    label={index === 0 ? "End Time" : ""}
                    value={session.end_time}
                    onChange={(value) =>
                      handleChangeSession(index, "end_time", value)
                    }
                  />
                </FormLayout.Group>
                <FormLayout.Group>
                  <Select
                    label="Gender"
                    options={[
                      { label: "Male", value: "male" },
                      { label: "Female", value: "female" },
                      {
                        label: "Mixed (With male,female capacities)",
                        value: "mixed",
                      },
                      {
                        label: "Mixed (With total capacity)",
                        value: "mixed_total",
                      },
                    ]}
                    onChange={(value) =>
                      handleChangeSession(index, "gender_type", value)
                    }
                    value={session.gender_type}
                    placeholder="Please select"
                  />
                  {(session.gender_type === "female" ||
                    session.gender_type === "mixed") && (
                    <TextField
                      label="Female Capacity"
                      value={session.capacity_female}
                      onChange={(value) =>
                        handleChangeSession(index, "capacity_female", value)
                      }
                    />
                  )}
                  {(session.gender_type === "male" ||
                    session.gender_type === "mixed") && (
                    <TextField
                      label="Male Capacity"
                      value={session.capacity_male}
                      onChange={(value) =>
                        handleChangeSession(index, "capacity_male", value)
                      }
                    />
                  )}
                  {session.gender_type === "mixed_total" && (
                    <TextField
                      label="Total Capacity"
                      value={session.capacity_total}
                      onChange={(value) =>
                        handleChangeSession(index, "capacity_total", value)
                      }
                    />
                  )}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: index === 0 ? "1.6rem" : "0rem",
                    }}
                  >
                    <Button
                      onClick={() => handleRemoveSession(index)}
                      variant="primary"
                      tone="critical"
                    >
                      Remove
                    </Button>
                  </div>
                </FormLayout.Group>
                <Divider borderColor="border-inverse" />
              </FormLayout>
            </div>
          ))} */}
              <Button
                fullWidth
                // variant="primary"
                onClick={handleAddSession}
                icon={PlusIcon}
              >
                Add Session
              </Button>
              <InlineError message={error} />
              <div style={{ height: "7rem" }}></div>
            </FormLayout>{" "}
          </div>
        ) : (
          <div className="spinnerContainer">
            <div className="vertical-center">
              <Spinner size="large" />
            </div>
          </div>
        )}
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      <Modal
        open={activeImport}
        onClose={handleChangeModalImport}
        title="Import Sessions"
        primaryAction={{
          content: "Submit",
          onAction: handleImport,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            loading: isSaving,
            onAction: handleChangeModalImport,
          },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <DropZone
              accept=".csv"
              onDrop={handleDropZoneDrop}
              allowMultiple={false}
              onDropAccepted={sendImage}
              error={true}
            >
              {uploadedFiles}
              {fileUpload}
            </DropZone>
            <InlineError message={importError} />
          </FormLayout>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function checkForEmptyValues(data) {
    const hasEmptyValues = data.some(
      (item) =>
        item.class === "" ||
        item.instructor === "" ||
        item.date === "" ||
        item.start_time === "" ||
        item.end_time === "" ||
        item.gender_type === "",
      // item.capacity_male === "" ||
      // item.capacity_female === ""
    );
    return hasEmptyValues;
  }
  function handleSave() {
    // console.log(sessions[0].start_time);
    if (checkForEmptyValues(sessions)) {
      setError("Please make sure that you have filled in all the inputs");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      sessions?.length
        ? sessions.forEach((selected, index) => {
            form_data.append(
              `bulk_sessions[${index}][launch_time]`,
              selected.start_time,
            );
            form_data.append(
              `bulk_sessions[${index}][finish_time]`,
              selected.end_time,
            );
            form_data.append(`bulk_sessions[${index}][date]`, selected.date);
            form_data.append(
              `bulk_sessions[${index}][gender]`,
              selected.gender_type,
            );
            form_data.append(
              `bulk_sessions[${index}][instructor_id]`,
              selected.instructor.value,
            );
            form_data.append(
              `bulk_sessions[${index}][class_id]`,
              selected.class.value,
            );
            form_data.append(
              `bulk_sessions[${index}][capacity_male]`,
              selected.capacity_male !== "" &&
                selected.gender_type !== "mixed_total"
                ? selected.capacity_male
                : 0,
            );
            form_data.append(
              `bulk_sessions[${index}][capacity_female]`,
              selected.capacity_female !== "" &&
                selected.gender_type !== "mixed_total"
                ? selected.capacity_female
                : 0,
            );
            form_data.append(
              `bulk_sessions[${index}][capacity]`,
              selected.capacity_total !== "" ? selected.capacity_total : 0,
            );
            form_data.append(
              `bulk_sessions[${index}][external_capacity]`,
              selected.external_capacity !== ""
                ? selected.external_capacity
                : 0,
            );
            form_data.append(
              `bulk_sessions[${index}][external_capacity]`,
              selected.external_capacity !== ""
                ? selected.external_capacity
                : 0
            );
            selected.id &&
              form_data.append(`bulk_sessions[${index}][id]`, selected.id);
            `bulk_sessions[${index}][location]` &&
              form_data.append(
                `bulk_sessions[${index}][location]`,
                selected.location,
              );
            `bulk_sessions[${index}][other_location]` &&
              form_data.append(
                `bulk_sessions[${index}][other_location]`,
                selected.location_other,
              );
          })
        : form_data.append(`bulk_sessions[]`, "");
      axios
        .post(`/bulk-sessions`, form_data)
        .then((result) => {
          setIsSaving(false);
          setToastContent("Changes have be saved successfully");
          toggleActive();
        })
        .catch((error) => {
          // Error
          console.log("error=", error);
          // setError("Please make sure that you have filled in all the inputs");
          //setIsSaving(false);
          if (error.response) {
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        });
    }
  }
};

export default BulkSessions;
